import React, {useEffect,Fragment,memo, useState, useRef, useContext} from 'react'
import { Navbar,Container,Nav,Dropdown, Form} from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import CustomToggle from '../../../dropdowns';
import { ROUTES } from '../../../../utilities/constant';

import { postApiCall, getApiCall } from '../../../../service/httpCall';
import { motion } from "framer-motion";
import { API_USER_LOGOUT , API_USER_LOGIN_AS, API_USER_LOGOUT_FROM, API_AGENT_SCHEDULE,
  API_COMPANY_PROFILE, API_NOTIFICATION_LIST } from '../../../../service/url';
import eventBus from "../CallIcon/eventBus";
import avatars1 from '../../../../assets/images/avatars/01.png'
import avatars7 from '../../../../assets/images/avatars/superAdminAvatar.jpg'
import avatars8 from '../../../../assets/images/avatars/blackAvatar.jpg'
import avatars9 from '../../../../assets/images/avatars/blueAvatar.jpg'
import avatars10 from '../../../../assets/images/avatars/corelAvatar.jpg'
import avatars11 from '../../../../assets/images/avatars/greenAvatar.jpg'
import avatars12 from '../../../../assets/images/avatars/pinkAvatar.jpg'
import avatars13 from '../../../../assets/images/avatars/yellowAvatar.jpg'
import { Storage, restoreActiveProfileFromSession, persistActiveLoginType } from "../../../../utilities/setting";
import Logo from '../../components/logo';
import AgentNotificationPopup from "../../components/AgentNotificationPopup";
import { AnimatedThemeToggler } from '../../../../views/dashboard/ThemeToggler';
import { useSelector } from 'react-redux';
import * as SettingSelector from '../../../../store/setting/selectors'
import { logoutUser, switchBack, switchBackUser } from '../../../../utilities/setting';
import { USER_ROLES_MAP_PROFILE, USER_ROLES } from '../../../../utilities/constant';
import { clearUser } from "../../../../store/setting/actions";
import "../../../../assets/custom/css/toggle.css"
import { Modal, Button } from "react-bootstrap";
import { ArrowClockwise } from 'react-bootstrap-icons';
import { FaSignOutAlt, FaRegUser, FaCheck, FaClock, FaExclamationTriangle, FaMinus, FaBell } from "react-icons/fa";
import { toast } from 'react-toastify';
import { BreakContext } from "../../../../router/context/BreakContext";
import socket from "../../../../utilities/socket";
import { useCallStore } from "../../../../router/zustand/callStore";

// PROFILE ICON BASED ON USER ROLE:
// SUPERADMIN -> MULTICOLOR
// SUB SUPERADMIN -> BLACK
// RESELLER -> BLUE / LIGHT BLUE
// COMPANY -> COREL / LIGHT ORANGE
// CALL CENTER -> GREEN / LIGHT GREEN
// CALL CENTER TEAMLEAD -> PINK
// AGENT -> YELLOW / LEMON

const Header = memo((props) => {
    const [isRefreshingCredits, setIsRefreshingCredits] = useState(false);
    const navigate = useNavigate();
    const navbarHide = useSelector(SettingSelector.navbar_show); 
    const headerNavbar = useSelector(SettingSelector.header_navbar);

    // State for userName, userRole and userCredits
    const [userName, setUserName] = useState('');
    const [userRoleLabel, setUserRoleLabel] = useState('');
    const [userCredits, setUserCredits] = useState(0);
    const [ttsCredits, setTtsCredits] = useState(0);
    const [userId, setUserId] = useState(null);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [showCompanyInAvailableCreditsHeading, setShowCompanyInAvailableCreditsHeading] = useState(false);

    const [hideForCallCenter, setHideForCallCenter] = useState(false);
    const [showModal, setShowModel] = useState(false)
    const [activeType, setActiveType] = useState(null);
    const [activeModal, setActiveModal] = useState("");
    const [activeModals, setActiveModals] = useState([]);
    const [showToast, setShowToast] = useState(false);
    const [toastProps, setToastProps] = useState(null);
    const [types, setTypes] = useState([])
    const [loggedInUserRole, setLoggedInUserRole] = useState(null);
    const [loggedInUserDetail, setLoggedInUserDetail] = useState({});
    const [agentGroups, setAgentGroups] = useState([]);
    const [showQueueTooltip, setShowQueueTooltip] = useState(false); // hover state
    const [queuePage, setQueuePage] = useState(0);
    const pageSize = 2;
    const totalPages = Math.ceil(agentGroups.length / pageSize);
    const [profileIcon, setProfileIcon] = useState(avatars1);

    const [loginTime, setLoginTime] = useState(0); // seconds
    const [idleTime, setIdleTime] = useState(0);
    const [agentSchedule, setAgentSchedule] = useState({})
    const [showTooltip, setShowTooltip] = useState(false);
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const { dotColor, countdown, userStatus, breakExceeded } = useContext(BreakContext);

    const [showLogoutModal, setShowLogoutModal] = useState(false);

    const [showNotificationModal, setShowNotificationModal] = useState(false);
    const [hasUnread, setHasUnread] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const [notifications, setNotifications] = useState([]);
    const [isNotificationLoading, setIsNotificationLoading] = useState(false);
    const localUpdatesRef = useRef({}); 
    const [isProcessing, setIsProcessing] = useState(false);
    const [processingAction, setProcessingAction] = useState(null);

    const timerRef = useRef(null);
    const loginTsRef = useRef(null);
    const idleTsRef = useRef(null); 



const fetchNotifications = async () => {
  setIsNotificationLoading(true);
    try {
      const resp = await getApiCall(API_NOTIFICATION_LIST);
      let apiData = resp?.data || resp;
      const readIds = JSON.parse(localStorage.getItem('read_notification_ids') || '[]');

      // Merge with local updates
      const merged = apiData
        .map((item) => {
          const local = localUpdatesRef.current[item.id];
          return {
            ...item,
            is_read: readIds.includes(item.id) ? true : item.is_read,
            is_deleted: local?.is_deleted ?? false,
          };
        })
        .filter((n) => !n.is_deleted);

      setNotifications(merged);

      const unreadExists = merged.some((n) => !n.is_read && n.is_general);
      setHasUnread(unreadExists);
    } catch (err) {
      console.error(err);
    }
    finally {
        setIsNotificationLoading(false); 
    }
  };


useEffect(() => {
  if (loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT) {
    fetchNotifications();
    const interval = setInterval(() => {
      fetchNotifications();
    }, 30000);

    return () => clearInterval(interval);
  }
}, [loggedInUserRole]);

   const unreadCount = notifications.filter(n => !n.is_read && n.is_general && !n.is_deleted).length;
   useEffect(() => {
        setHasUnread(unreadCount > 0);
    }, [unreadCount]);


    const resetCtiIdlePersistence = () => {
      try {
        useCallStore.getState().setWebrtcPhoneStatus("");
        useCallStore.getState().setWebrtcPhoneStartTime("");
      } catch (e) {
        console.log("Failed to reset CTI idle persistence", e);
      }
    };

    const handleBellClick = (event) => {
      const rect = event.target.getBoundingClientRect();
      setPosition({
        top: rect.top,
        left: rect.left,
      });
      setShowNotificationModal((prevState) => !prevState); // Toggle popup visibility
    };


    useEffect(() => {
      const handleReset = () => {
        setActiveType(null);
      };
      eventBus.on("RESET_ACTIVE", handleReset);
      return () => {
        eventBus.off("RESET_ACTIVE", handleReset);
      };
    }, []);


    useEffect(() => {
      const loadTimers = async () => {
        if (!loggedInUserRole) return;

        const now = Date.now();

        let loginTimestamp = Storage.getItem('loginTimestamp');
        let idleTimestamp = Storage.getItem('idleTimestamp');

        if (!loginTimestamp) {
          loginTimestamp = now.toString();
          Storage.setItem('loginTimestamp', loginTimestamp, true);
        }
        
        if (!idleTimestamp) {
          idleTimestamp = now.toString();
          Storage.setItem('idleTimestamp', idleTimestamp, true);
        }

        loginTsRef.current = parseInt(loginTimestamp);
        idleTsRef.current = parseInt(idleTimestamp);

        startTimers();

        
      };

      loadTimers();

      return () => {
        if (timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
        }
      };
    }, [loggedInUserRole]);

    const startTimers = () => {
      if (timerRef.current) return; // prevent multiple intervals

      timerRef.current = setInterval(() => {
        const now = Date.now();

        setLoginTime(Math.floor((now - loginTsRef.current) / 1000));
        setIdleTime(Math.floor((now - idleTsRef.current) / 1000));
      }, 1000);
    };


    useEffect(() => {
      let isMounted = true;
      if (!loggedInUserDetail?.agentData?.id) return ;
      const fetchAgentGroups = async () => {
        try {
          const resp = await getApiCall(
            `${API_AGENT_SCHEDULE}/${loggedInUserDetail?.agentData?.id}`
          );

          if (isMounted) {
            setAgentGroups(resp?.groups || []);
            setAgentSchedule(resp?.scheduleData || {});
          }

        } catch (err) {
          console.log(err)
          if (isMounted) setAgentGroups([]);
        }
      };

      fetchAgentGroups();

      return () => {
        isMounted = false;
      };
    }, [
      loggedInUserRole?.role,
      loggedInUserDetail?.agentData?.id
    ]);


   const formatTime = (secs) => {
      const minutes = String(Math.floor(secs / 60)).padStart(2, "0");
      const seconds = String(secs % 60).padStart(2, "0");
      return `${minutes}:${seconds}`;
    };

const refreshCredits = async () => {
    if (isRefreshingCredits) return;
    setIsRefreshingCredits(true);
    try {
      const rawUser = Storage.getItem('user');
      if (!rawUser) {
        console.error("User data not found in Storage");
        return;
      }

      const user = JSON.parse(rawUser);

      // if(user.id && user?.role === USER_ROLES.COMPANY_ADMIN) {
      //   let apiUrl = API_USERS_PROFILE.replace(":id", user.id);
      //   const resp = await getApiCall(apiUrl, {});
      //   setTtsCredits(resp?.tts_credits || "0.00");
      // }

      if(user.id && (user?.role === USER_ROLES.COMPANY_ADMIN || user?.role === USER_ROLES.RESELLER || user?.role === USER_ROLES.CALL_CENTRE_ADMIN)) {
        let apiUrl = API_COMPANY_PROFILE.replace(":id", user?.assignedCompany?.id);
        const resp = await getApiCall(apiUrl, {});
        setUserCredits(resp?.credits_available || "0.00");
        setTtsCredits(resp?.tts_credits || "0.00");
      } 
      // else {
      //   setUserCredits(user?.company?.credits_available || "0.00");
      // }

    }catch (error) {
      console.error("Error refreshing credits:", error);
      toast.error("Failed to refresh credits");
    } finally {
      setIsRefreshingCredits(false);
    }
  };



    useEffect(() => {
        // Initial fetch from Storage
        const fetchUserData = async () => {
            // Refresh-survival: if a previous tab persisted the active login type
            // but a race during reload flipped Storage's active_profile to false,
            // restore it before any consumer reads it.
            restoreActiveProfileFromSession();

            const rawUser = Storage.getItem('user');

            if (!rawUser) {
              console.error("User data not found in Storage");
              return;
            }

            let user;
            try {
              user = JSON.parse(rawUser);
            } catch (e) {
              console.error("Invalid JSON in Storage user:", e);
              return;
            }

            if (user && user?.role) {
              if (user?.role === USER_ROLES.SUPERADMIN) {
                setProfileIcon(avatars7);
              } else if (user?.role === USER_ROLES.SUB_SUPERADMIN) {
                setProfileIcon(avatars8);
              } else if (user?.role === USER_ROLES.RESELLER) {
                setProfileIcon(avatars9);
              } else if (user?.role === USER_ROLES.COMPANY_ADMIN) {
                setProfileIcon(avatars10);
              } else if (user?.role === USER_ROLES.CALL_CENTRE_ADMIN) {
                setProfileIcon(avatars11);
              } else if (user?.role === USER_ROLES.CALL_CENTRE_TEAM_LEAD) {
                setProfileIcon(avatars12);
              } else if (user?.role === USER_ROLES.CALL_CENTRE_AGENT) {
                setProfileIcon(avatars13);
              } else {
                setProfileIcon(avatars1);
              }
            }

            const profile = user?.agentData?.agentTelephony?.profile

            if (profile) {
                const types = profile.map(item => item.type);

                console.log("TYPES INCLUDED", types);
                setTypes(types)
                const activeProfile = profile.find(item => item.active_profile === true);
                if (activeProfile) {
                setActiveType(activeProfile.type);
                // Mirror to session + local so HeaderModals + refresh-restore both work
                persistActiveLoginType(activeProfile.type);
                // Dispatch custom event for same-tab listeners
                window.dispatchEvent(new CustomEvent('sessionStorageChange', {
                  detail: { key: 'activeLoginType', value: activeProfile.type }
                }));
                } else {
                // Clear if no active profile
                persistActiveLoginType(null);
                // Dispatch custom event for same-tab listeners
                window.dispatchEvent(new CustomEvent('sessionStorageChange', {
                  detail: { key: 'activeLoginType', value: null }
                }));
                }
            }

            setLoggedInUserDetail(user)
          
            setUserName(user?.username || '');
            setLoggedInUserRole(user?.role);
            if (user?.role === USER_ROLES.COMPANY_ADMIN || user?.role === USER_ROLES.RESELLER || user?.role === USER_ROLES.CALL_CENTRE_ADMIN) {
                setShowCompanyInAvailableCreditsHeading(true);
            } else {
                setShowCompanyInAvailableCreditsHeading(false);
            }

            if (user?.role === USER_ROLES.CALL_CENTRE_AGENT || user?.role === USER_ROLES.CALL_CENTRE_TEAM_LEAD) {
                setHideForCallCenter(true);
            } else {
                setHideForCallCenter(false);
            }
            setUserRoleLabel(USER_ROLES_MAP_PROFILE[user?.role] || '');
            setIsSuperAdmin(user?.role === USER_ROLES.SUPERADMIN);
            setUserId(user?.id);

            if (user.id && (user?.role === USER_ROLES.COMPANY_ADMIN || user?.role === USER_ROLES.RESELLER || user?.role === USER_ROLES.CALL_CENTRE_ADMIN)) {
              let apiUrl = API_COMPANY_PROFILE.replace(":id", user?.assignedCompany?.id);
                getApiCall(apiUrl, {})
                .then((resp) => {
                    setTtsCredits(resp?.tts_credits || "0.00");
                    setUserCredits(resp?.credits_available || "0.00");
                })
                .catch(onError)
            }

            // if (user.id && user?.role !== USER_ROLES.COMPANY_ADMIN) {
            //     let apiUrl = API_COMPANY_PROFILE.replace(":id", user?.assignedCompany?.id);
            //     getApiCall(apiUrl, {})
            //     .then((resp) => {
            //         setUserCredits(resp?.credits_available || "0.00");
            //         setTtsCredits(resp?.tts_credits || "0.00");
            //     })
            //     .catch(onError)
            //   } else {
            //     setUserCredits(user?.company?.credits_available || "0.00");
            //   }
          };
          

        // fetchUserData().then(() => {
        //   if (loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT) {
        //     checkAndRestoreBreak();
        //   }
        // })
        // fetchUserData().then(checkAndRestoreBreak)
        fetchUserData()
        
        // Initialize activeModals from sessionStorage
        const savedActiveModal = sessionStorage.getItem("activeModal");
        if (savedActiveModal) {
            try {
                const parsed = JSON.parse(savedActiveModal);
                if (Array.isArray(parsed)) {
                    setActiveModals(parsed);
                } else if (typeof parsed === 'string') {
                    setActiveModals([parsed]);
                }
            } catch (e) {
                setActiveModals(savedActiveModal ? [savedActiveModal] : []);
            }
        }
        
        // navbarstylemode
        if (headerNavbar === 'navs-sticky' || headerNavbar === 'nav-glass') {
            window.onscroll = () => {
                if (document.documentElement.scrollTop > 50) {
                    document.getElementsByTagName('nav')[0].classList.add('menu-sticky')
                } else {
                    document.getElementsByTagName('nav')[0].classList.remove('menu-sticky')
                }
            }
        }

     }, []);

     // Listen for sessionStorage changes to sync modal states
     useEffect(() => {
         const handleStorageChange = (e) => {
             // Handle both storage events (cross-tab) and custom events (same-tab)
             const key = e.key || (e.detail && e.detail.key);
             
             if (key === "activeModal") {
                 const savedActiveModal = sessionStorage.getItem("activeModal");
                 if (savedActiveModal) {
                     try {
                         const parsed = JSON.parse(savedActiveModal);
                         if (Array.isArray(parsed)) {
                             setActiveModals(parsed);
                         } else if (typeof parsed === 'string') {
                             setActiveModals([parsed]);
                         }
                     } catch (e) {
                         setActiveModals(savedActiveModal ? [savedActiveModal] : []);
                     }
                 } else {
                     setActiveModals([]);
                 }
             }
         };

         // Add storage event listener
         window.addEventListener('storage', handleStorageChange);
         
         // Also add a custom event listener for same-tab updates
         window.addEventListener('sessionStorageChange', handleStorageChange);

         return () => {
             window.removeEventListener('storage', handleStorageChange);
             window.removeEventListener('sessionStorageChange', handleStorageChange);
         };
     }, []);

   const minisidebar =() =>{
       document.getElementsByTagName('ASIDE')[0].classList.toggle('sidebar-mini')
   }


   function onError(err){
        console.log(err);
   }

   async function logout(isDashboardOnly = false) {
    if (isLoggingOut) return;
    try {
        // Check if agent is logged in from Soft Phone, Mobile, or WEBRTC
        // if (activeType && (activeType === "Soft Phone" || activeType === "Mobile" || activeType === "WEBRTC")) {
        //     toast.error(`Agent is logged in from ${activeType}. Please logout from ${activeType} first.`);
        //     return;
        // }
        if (
          activeType === "Mobile" &&
          !isDashboardOnly &&
          !showLogoutModal
        ) {
          setShowLogoutModal(true);
          return;
        }
        setIsLoggingOut(true);
        
        if (loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT) {
          socket.disconnect();
        }
        
        let userStack = Storage.getItem('userStack');
        userStack = userStack ? JSON.parse(userStack) : [];

        // Always call logout API
        await postApiCall(`${API_USER_LOGOUT}/${userId}`, {
          onlyLogoutFromDashboard: isDashboardOnly
        });

        Storage.multiRemove([
        'showPhone', 'showHistory', 'showForm',
        'positionPhone', 'positionHistory', 'positionForm'
        ]);

        if (timerRef.current) {
         clearInterval(timerRef.current);
          timerRef.current = null;
        }
        setLoginTime(0);
        setIdleTime(0);

        Storage.multiRemove(['loginTimestamp', 'idleTimestamp']);
        resetCtiIdlePersistence();
        
        if (userStack.length > 0) {
            const switchedBack = await switchBackUser();

            if (switchedBack) {
                window.location.href = `/${ROUTES.DASHBOARD}`;
            } else {
                console.log("Failed to switch back user");
            }
        } else {
            await logoutUser();
            clearUser();
            Storage.removeItem('userStack');
            window.location.href = `/${ROUTES.LOGIN}`;
        }
    } catch (error) {
        if (error.includes("TokenExpiredError")) {
            Storage.clearAll()
                .then(() => {
                setTimeout(() => {
                    navigate(`/${ROUTES.LOGIN}`);
                    setShowToast(false); 
                    }, 1000);
            })
            // setToastProps({ message: "Session Expired", type: "danger" });
          toast.error("Session Expired");
        }
        // setToastProps({ message: error, type: "danger" });
          toast.error(error);
        console.error('Logout error:', error);
     } finally {
        setIsLoggingOut(false);
     }
    }

    async function loginAs(type) {
        try {
            const params = {
                type: type
            }
            const resp = await postApiCall(`${API_USER_LOGIN_AS}/${userId}`, params);
            //update Storage
            const rawUser = Storage.getItem('user');
            let user = rawUser ? JSON.parse(rawUser) : null;

            if (user && user.agentData?.agentTelephony?.profile) {
              user.agentData.agentTelephony.profile = user.agentData.agentTelephony.profile.map(p => ({
                ...p,
                active_profile: p.type === type 
              }));
            }
            Storage.setItem('user', JSON.stringify(user));
            if (type === "WEBRTC") {
              // navigate(`/${ROUTES.DASHBOARD}`);
              // window.location.href = `/${ROUTES.DASHBOARD}`;
              // window.location.reload();
              // const hiddenButton = document.createElement("button");
              // hiddenButton.className = "keypadConnect2";
              // hiddenButton.style.display = "none"; 
              // document.body.appendChild(hiddenButton);

              require("../CallIcon/demo-1");
              // sessionStorage.setItem("showWebrtc", "YES");
            
              const buttonObj = document.getElementsByClassName("keypadConnect2");
              for(let o of buttonObj){
                              o.click();
              }


              //hiddenButton.click();
              handleButtonClick("WEB");
            }
            toast.success(`Logged In as: ${type}`);
            // setToastProps({ type: 'success', message: `Logged In as: ${type}` });

            setShowToast(true);
            setActiveType(type);
            // Mirror to session + local so refresh restores the active profile
            persistActiveLoginType(type);
            // Dispatch custom event for same-tab listeners
            window.dispatchEvent(new CustomEvent('sessionStorageChange', {
              detail: { key: 'activeLoginType', value: type }
            }));
            setShowModel(false)
          
        } catch (error) {
            // setToastProps({ type: 'danger', message: error || `Error while Logged In as: ${activeType}` });
          toast.error(error || `Error while Logged In as: ${activeType}`);
            setShowToast(true);
            console.error('LoginAs error:', error);
        }
    }

    async function logoutAs(type) {
        try {
            const params = {
                type: type
            }
            const resp = await postApiCall(`${API_USER_LOGOUT_FROM}/${userId}`, params);
            // Update Storage
            const rawUser = Storage.getItem('user');
            let user = rawUser ? JSON.parse(rawUser) : null;

            if (user && user.agentData?.agentTelephony?.profile) {
              user.agentData.agentTelephony.profile = user.agentData.agentTelephony.profile.map(p => ({
                ...p,
                active_profile: p.type === type ? false : p.active_profile
              }));

              Storage.setItem('user', JSON.stringify(user));
            }
            
          toast.success(`Logged Out From: ${activeType}`);
          resetCtiIdlePersistence();
          if (type === "WEBRTC") {
              // navigate(`/${ROUTES.DASHBOARD}`);
              // window.location.href = `/${ROUTES.DASHBOARD}`;
              // window.location.reload();

              // const hiddenButton = document.createElement("button");
              // hiddenButton.className = "disconnect2";
              // hiddenButton.style.display = "none"; 
              // document.body.appendChild(hiddenButton);

              require("../CallIcon/demo-1");
              sessionStorage.setItem("showWebrtc", "NO");
              const modals = JSON.parse(sessionStorage.getItem("activeModal") || "[]");
              const updatedModals = modals.filter(modal => modal !== "WEB");
              sessionStorage.setItem("activeModal", JSON.stringify(updatedModals));

              const buttonObj = document.getElementsByClassName("disconnect2");
              for(let o of buttonObj){
                              o.click();
              }
              sessionStorage.removeItem("webrtcPhoneStatus");

               

              //hiddenButton.click();
            }
            setShowToast(true);
            const activeProfile = resp.find(item => item.type === true);
            const newActiveType = activeProfile?.type || null;
            setActiveType(newActiveType);
            // Update persistent active type (session + local) when activeType changes
            persistActiveLoginType(newActiveType);
            window.dispatchEvent(new CustomEvent('sessionStorageChange', {
              detail: { key: 'activeLoginType', value: newActiveType }
            }));
            
            // Close the WebRTC Phone modal when logging out from Soft Phone, Mobile, or WEBRTC
            if (type === "Soft Phone" || type === "Mobile" || type === "WEBRTC") {
                setActiveModals(prev => {
                    const newModals = prev.filter(modal => modal !== "WEB");
                    // Update sessionStorage
                    if (newModals.length > 0) {
                        sessionStorage.setItem("activeModal", JSON.stringify(newModals));
                    } else {
                        sessionStorage.removeItem("activeModal");
                    }
                    return newModals;
                });
                sessionStorage.removeItem("webrtcPhoneStatus");
            };
            
            // Close the WebRTC Phone modal when logging out from Soft Phone, Mobile, or WEBRTC
            if (type === "Soft Phone" || type === "Mobile" || type === "WEBRTC") {
                setActiveModals(prev => {
                    const newModals = prev.filter(modal => modal !== "WEB");
                    // Update sessionStorage
                    if (newModals.length > 0) {
                        sessionStorage.setItem("activeModal", JSON.stringify(newModals));
                    } else {
                        sessionStorage.removeItem("activeModal");
                    }
                    return newModals;
                });
                sessionStorage.removeItem("webrtcPhoneStatus");
            }
        } catch (error) {
            // setToastProps({ type: 'danger', message: `Error while Logged Out From: ${activeType}` });
          toast.error(`Error while Logged Out From: ${activeType}`);
            setShowToast(true);
        }
    }

    const handleButtonClick = (modalType) => {
        setActiveModals(prev => {
            const isActive = prev.includes(modalType);
            let newModals;
            
            if (isActive) {
                // Remove the modal if it's already active
                newModals = prev.filter(modal => modal !== modalType);
            } else {
                // Add the modal if it's not active
                newModals = [...prev, modalType];
            }
            
            // Save to sessionStorage for HeaderModals to read
            sessionStorage.setItem("activeModal", JSON.stringify(newModals));
            
            // Show the phone panel if not already shown (for WEB modal)
            if (modalType === "WEB" && !sessionStorage.getItem("showPhone")) {
                sessionStorage.setItem("showPhone", "true");
            }
            
            return newModals;
        });
        
        // Update the single activeModal for backward compatibility
        setActiveModal(modalType);
    };

      // const tooltipText =
      //   userStatus === "BREAK"
      //   ? "Agent can start taking calls after ending the break."
      //   : "";

    return (
        <>
        <Fragment>
            {(isProcessing || isLoggingOut) && (
              <div
                style={{
                  position: "fixed",
                  inset: 0,
                  // background: "rgba(8, 6, 61, 0.55)",
                  backdropFilter: "blur(2px)",
                  zIndex: 99999,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pointerEvents: "all",
                }}
                aria-live="polite"
                aria-busy="true"
              >
                <div
                  style={{
                    background: "#ffffff",
                    borderRadius: "14px",
                    padding: "22px 28px",
                    minWidth: "280px",
                    boxShadow: "0 12px 32px rgba(0,0,0,0.25)",
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                  }}
                >
                  <div
                    style={{
                      width: "28px",
                      height: "28px",
                      border: "3px solid #e5e7eb",
                      borderTopColor: "rgb(112, 0, 164)",
                      borderRadius: "50%",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <span style={{ fontSize: "14px", fontWeight: 600, }}>
                      {isLoggingOut
                        ? "Signing out..."
                        : processingAction
                        ? `${processingAction.verb} ${processingAction.type}...`
                        : "Processing..."}
                    </span>
                    <span style={{ fontSize: "12px", marginTop: "2px" }}>
                      Please do not refresh or close this tab.
                    </span>
                  </div>
                </div>
              </div>
            )}
            <Navbar expand="lg" variant="light" className={`nav iq-navbar ${headerNavbar} ${navbarHide.join(" ")}`} style={{
              // background: "linear-gradient(45deg, #08063d, rgb(7,64,141))" ,
              backgroundColor: "#04005a"
              }}>
                <Container fluid className="navbar-inner">
                    <Link to="/dashboard" className="navbar-brand">
                        <Logo color={true} />
                        <h4 className="logo-title" style={{ color: "white", fontSize: "17px" }}>Cloud Telephony</h4>
                    </Link>
                    <div className="sidebar-toggle" data-toggle="sidebar" data-active="true" onClick={minisidebar}>
                        <i className="icon">
                            <svg width="20px" height="20px" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                            </svg>
                        </i>
                    </div>
                    {/* <div className="input-group search-input">
                        <span className="input-group-text" id="search-input">
                            <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                                <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </span>
                        <input type="search" className="form-control" placeholder="Search..."/>
                    </div> */}
                    <Navbar.Toggle aria-controls="navbarSupportedContent">
                        <span className="navbar-toggler-icon">
                            <span className="mt-2 navbar-toggler-bar bar1"></span>
                            <span className="navbar-toggler-bar bar2"></span>
                            <span className="navbar-toggler-bar bar3"></span>
                        </span>
                    </Navbar.Toggle>
                    
                    <Navbar.Collapse  id="navbarSupportedContent">
                        <Nav as="ul" className="mb-2 ms-auto navbar-list mb-lg-0 align-items-center">
                          <div style={{ marginTop: "5px", marginRight: "10px" }}>
                            <AnimatedThemeToggler className="theme-toggle-btn mb-2" />
                            </div>
                            {(!isSuperAdmin && !hideForCallCenter) && <div style={{ marginRight: "30px" }}>
                              <h6 className='mb-0 caption-title' style={{color: 'white'}} title="Company Voice Credits">Voice Credits: {userCredits}</h6>
                            </div>
                            }
                            {(loggedInUserRole !== USER_ROLES.SUPERADMIN && loggedInUserRole !== USER_ROLES.CALL_CENTRE_AGENT && loggedInUserRole !== USER_ROLES.CALL_CENTRE_TEAM_LEAD) && <div style={{ marginRight: "30px", display: "flex", alignItems: "center" }}>
                              <h6 className='mb-0 caption-title' style={{color: 'white', marginRight: "10px"}} title="Company TTS Credits">TTS Credits: {ttsCredits}</h6>
                              <div className=' rounded-full refresh-button' style={{
                    borderRadius:"50%",
                    padding:"8px",
                    // background:"linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    // boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                    transition: "all 0.3s ease",
                    border: "2px solid rgba(255, 255, 255, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                  onMouseOver={(e) => {
                    if (!isRefreshingCredits) {
                      e.currentTarget.style.transform = "scale(1.1)";
                      // e.currentTarget.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.6)";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!isRefreshingCredits) {
                      e.currentTarget.style.transform = "scale(1)";
                      // e.currentTarget.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.4)";
                    }
                  }}>
                    <ArrowClockwise
                      size={17}
                      color="white "
                      className=''
                      style={{
                        cursor: isRefreshingCredits ? "not-allowed" : "pointer",
                        opacity: isRefreshingCredits ? 0.5 : 1,
                        animation: isRefreshingCredits ? "spin 1s linear infinite" : "none"
                      }}
                      onClick={refreshCredits}
                    />
                  </div>

                            </div>
                            }

                            {loggedInUserRole && loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT && (
                              <>
                                          <div
                                            style={{ position: "relative", cursor: "pointer", marginRight: "10px" }}
                                            onClick={handleBellClick}
                                          >
                                            <FaBell size={20} color="white" />

                                            {/* Red Dot */}
                                          {unreadCount > 0 && (
                                         <span
                                           style={{
                                             position: "absolute",
                                             top: "-8px",      
                                             right: "-10px",
                                             backgroundColor: "rgb(158, 0, 0)",
                                             color: "white",
                                             borderRadius: "50%",
                                             padding: "2px 6px",
                                             fontSize: "10px",
                                             fontWeight: "bold",
                                             minWidth: "18px",
                                             height: "18px",
                                             display: "flex",
                                             alignItems: "center",
                                             justifyContent: "center",
                                            //  border: "2px solid #081d5d" 
                                                }}
                                              >
                                                {unreadCount}
                                              </span>
                                            )}

                                          {showNotificationModal && (
                                             <AgentNotificationPopup
                                              show={showNotificationModal}
                                              onHide={() => setShowNotificationModal(false)}
                                              setHasUnread={setHasUnread}
                                              isLoading={isNotificationLoading}
                                              notifications={notifications} 
                                              setNotifications={setNotifications} 
                                              position={position}
                                            />
                                          )}
                                          </div>
                                <Dropdown as="li" className="nav-item me-2">
                                  <div style={{ display: "flex", alignItems: "center" }} 
                                  // title={"Login/Logout Options"}
                                  >
                                    
                                    {/* Tooltip Wrapper */}
                                    <div
                                      style={{ position: "relative", display: "inline-block" }}
                                      onMouseEnter={() => setShowTooltip(true)}
                                      onMouseLeave={() => setShowTooltip(false)}
                                    >
                                      {/* Button Wrapper (handles disabled hover issue) */}
                                      <div style={{ display: "inline-block" }}>
                                        <span 
                                        >
                                          <Dropdown.Toggle
                                            id="navbarDropdownCalls"
                                            variant="dark"
                                            className="px-4 py-2 rounded border-0 rounded-pill agent-call-dropdown-toggle"
                                            // disabled={userStatus === "BREAK"}
                                            style={{
                                              backgroundColor: "rgb(112, 0, 164)",
                                              border: "1px solid rgb(112, 0, 164)",
                                              borderRadius: "40px",
                                              padding: "3px 14px",
                                              fontSize: "14px",
                                              color: "#fffdf8f5",
                                              boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {activeType ? (
                                              <>
                                                Logout from:{" "}
                                                <strong style={{ color: "#00ff80" }}>
                                                  {activeType}
                                                </strong>
                                              </>
                                            ) : (
                                              "Login to take calls"
                                            )}
                                          </Dropdown.Toggle>
                                        </span>
                                      </div>

                                      {/* Tooltip */}
                                      {/* {showTooltip && tooltipText && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: "120%",
                                            right: "-50%",
                                            backgroundColor: "#fff5f5",
                                            borderRadius: "8px",
                                            boxShadow: "0 16px 32px rgba(0,0,0,0.18)",
                                            padding: "10px",
                                            minWidth: "340px",
                                            zIndex: 9999,
                                            border: "1px solid rgba(220,53,69,0.35)",
                                            color: "#842029",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {tooltipText}
                                        </div>
                                      )} */}
                                    </div>

                                    {/* Dropdown Menu */}
                                    <Dropdown.Menu
                                      className="dropdown-menu-end agent-call-dropdown-menu"
                                      aria-labelledby="navbarDropdownCalls"
                                      style={{ height: "auto", width: "200px" }}
                                    >
                                      {["Soft Phone", "Mobile", "WEBRTC"].map((type) => {
                                        if (!types.includes(type)) return null;

                                        const isActive = activeType === type;
                                        const isDisabled = type === "Soft Phone";

                                        return (
                                          <Dropdown.Item
                                            key={type}
                                            as="div"
                                            className="agent-call-dropdown-item"
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              padding: "12px 14px",
                                              borderRadius: "12px",
                                              marginTop: "8px",
                                              background: "rgba(235, 235, 235, 0.03)",
                                              transition: "all 0.25s ease",
                                            }}
                                          >
                                            {/* TEXT */}
                                            <div
                                              className="agent-call-dropdown-copy"
                                              style={{ display: "flex", flexDirection: "column" }}
                                            >
                                              <span style={{ fontSize: "14px", fontWeight: 500 }}>
                                                {type}
                                              </span>

                                              <span
                                                style={{
                                                  fontSize: "11px",
                                                  marginTop: "2px",
                                                  fontWeight: 500,
                                                }}
                                              >
                                                {isDisabled ? "Disabled" : isActive ? "Active" : "Inactive"}
                                              </span>
                                            </div>

                                            {/* SWITCH */}
                                            <div
                                              onClick={async () => {
                                                if (isDisabled || isProcessing) return;
                                                try {
                                                  setIsProcessing(true);
                                                  if (isActive) {
                                                    setProcessingAction({ verb: "Logging out from", type });
                                                    await logoutAs(type);
                                                  } else {
                                                    if (activeType && activeType !== type) {
                                                      setProcessingAction({ verb: "Logging out from", type: activeType });
                                                      await logoutAs(activeType);
                                                    }
                                                    setProcessingAction({ verb: "Logging in to", type });
                                                    await loginAs(type);
                                                  }
                                                } finally {
                                                  setIsProcessing(false);
                                                  setProcessingAction(null);
                                                }
                                              }}
                                              style={{
                                                width: "44px",
                                                height: "24px",
                                                borderRadius: "50px",
                                                background: isDisabled
                                                  ? "#3a3a3c"
                                                  : isActive
                                                  ? "linear-gradient(135deg, #34c759, #30d158)"
                                                  : "#2c2c2e",
                                                display: "flex",
                                                alignItems: "center",
                                                padding: "3px",
                                                cursor: isDisabled || isProcessing ? "not-allowed" : "pointer",
                                                opacity: isDisabled || isProcessing ? 0.5 : 1,
                                              }}
                                            >
                                              <motion.div
                                                transition={{
                                                  type: "spring",
                                                  stiffness: 500,
                                                  damping: 30,
                                                }}
                                                style={{
                                                  width: "18px",
                                                  height: "18px",
                                                  borderRadius: "50%",
                                                  background: "#fff",
                                                }}
                                                animate={{
                                                  x: isDisabled ? 0 : isActive ? 20 : 0,
                                                }}
                                              />
                                            </div>
                                          </Dropdown.Item>
                                        );
                                      })}
                                    </Dropdown.Menu>
                                  </div>
                                </Dropdown>
                              </>  
                            )}


                            {loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT && (
                              <>
                                {(countdown !== null && countdown > 0 && userStatus === 'BREAK') && (
                                  <div
                                    className="d-flex align-items-center gap-2"
                                    style={{
                                      backgroundColor: "#f70303ff",
                                      border: "1px solid #f70303ff",
                                      borderRadius: "999px",
                                      padding: "6px 14px",
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      color: "#faf9f7ff",
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                      cursor: "pointer",
                                       marginRight: '5px'
                                    }}
                                    title="Break Remaining"
                                    // onClick={() => setShowCancelModal(true)}
                                  >
                                    <FaClock size={14} />
                                    <span>Break</span>
                                    <span style={{ fontWeight: 700 , minWidth: '50px', display: 'inline-block', textAlign: 'right' }}>
                                      {formatTime(countdown)}
                                    </span>
                                  </div>
                                )}
                                {(breakExceeded &&  userStatus === 'BREAK') && (
                                  <div
                                    className="d-flex align-items-center gap-2"
                                    style={{
                                      backgroundColor: "#fdecea",
                                      border: "1px solid #dc3545",
                                      borderRadius: "999px",
                                      padding: "6px 14px",
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      color: "#842029",
                                      boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                      cursor: "pointer",
                                       marginRight: '5px'
                                    }}
                                    title="Break Time Exceeded"
                                  >
                                    <FaExclamationTriangle size={14} />
                                    <span>Break Exceeded</span>
                                  </div>
                                )}
                                    {/* <div
                                      className="d-flex align-items-center gap-2"
                                      style={{
                                        backgroundColor: "#fce28aff",
                                        border: "1px solid #ffc107",
                                        borderRadius: "999px",
                                        padding: "6px 14px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#856404",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                        cursor: "pointer",
                                        marginRight: '5px'
                                      }}
                                      title="Idle Time"
                                    >
                                      <FaClock size={14} />
                                      <span>Idle</span>
                                      <span style={{ fontWeight: 700 , minWidth: '50px', display: 'inline-block', textAlign: 'right' }}>
                                        {formatTime(idleTime)}
                                      </span>
                                    </div> */}
                              </>
                            )}

                                    <div
                                      className="d-flex align-items-center gap-2"
                                      style={{
                                        backgroundColor: "#4bb567ff",
                                        border: "1px solid #4bb567ff",
                                        borderRadius: "999px",
                                        padding: "6px 14px",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        color: "#fffdf8f5",
                                        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                                        cursor: "pointer",
                                      }}
                                      title="Online Time"
                                      // onClick={() => setShowCancelModal(true)}
                                    >
                                      <FaClock size={14} />
                                      <span>Online</span>
                                      <span style={{ fontWeight: 700, minWidth: '50px', display: 'inline-block', textAlign: 'right'  }}>
                                        {formatTime(loginTime)}
                                      </span>
                                    </div>


                            <Dropdown as="li" className="nav-item">
                                {/* <Dropdown.Toggle as={CustomToggle} variant=" nav-link py-0 d-flex align-items-center" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <img src={avatars1} alt="User-Profile" className="theme-color-default-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    <img src={avatars2} alt="User-Profile" className="theme-color-purple-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    <img src={avatars3} alt="User-Profile" className="theme-color-blue-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    <img src={avatars5} alt="User-Profile" className="theme-color-green-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    <img src={avatars6}alt="User-Profile" className="theme-color-yellow-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    <img src={avatars4} alt="User-Profile" className="theme-color-pink-img img-fluid avatar avatar-50 avatar-rounded"/>
                                    <div className="caption ms-3 d-none d-md-block ">
                                        <p className="mb-0 caption-sub-title" style={{color: 'white'}}>{userRoleLabel}</p>
                                        <h6 className="mb-0 caption-title" style={{color: 'white'}}>{userName}</h6>
                                    </div>
                                </Dropdown.Toggle> */}
                                <Dropdown.Toggle
                                  as={CustomToggle}
                                  variant="nav-link py-0 d-flex align-items-center"
                                  id="navbarDropdown"
                                >
                                  <div style={{ position: "relative" }} title="User Profile">
                                    <img
                                      src={profileIcon}
                                      alt="User-Profile"
                                      className="img-fluid avatar avatar-50 avatar-rounded"
                                    />

                                    {/* STATUS BADGE */}
                                    <span
                                      style={{
                                        position: "absolute",
                                        bottom: "1px",
                                        right: "1px",
                                        width: "18px",
                                        height: "18px",
                                        borderRadius: "50%",
                                        backgroundColor: dotColor,
                                        // backgroundColor: 'green',
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        border: "2px solid white",
                                      }}
                                    >
                                     {breakExceeded ? <FaMinus style={{ color: "white", fontSize: "9px" }} /> 
                                     : <FaCheck style={{ color: "white", fontSize: "9px" }} />} 
                                    </span>
                                  </div>

                                  <div className="caption ms-3 d-none d-md-block" title="User Profile">
                                    <p className="mb-0 caption-sub-title" style={{ color: "white" }}>
                                      Role: {userRoleLabel}
                                    </p>
                                    <h6 className="mb-0 caption-title" style={{ color: "white" }}>
                                      {userName}
                                    </h6>
                                  </div>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu-end p-2 user-dropdown">
                                  
                                  {/* User Header */}
                                  <div className="d-flex align-items-center mb-3">
                                    <div className="user-avatar me-2">
                                    <div className="avatar-circle">
                                      <img
                                        src={profileIcon}
                                        alt="User-Profile"
                                        className="avatar-img"
                                      />
                                    </div>

                                    </div>
                                    <div className="user-info">
                                      <div className="fw-bold user-name">
                                        {loggedInUserDetail?.username}
                                      </div>

                                      <div className="text-muted small">
                                        Role: {" "}
                                        {USER_ROLES_MAP_PROFILE[loggedInUserDetail?.role] || ''}
                                      </div>

                                      <div className="text-muted small user-email">
                                        {loggedInUserDetail?.email}
                                      </div>
                                    </div>

                                  </div>

                                  <Dropdown.Divider />
                                  <Dropdown.Item
                                    as={Link}
                                    to={`/${ROUTES.PROFILE}`}
                                    className="d-flex align-items-center px-0 py-1"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <FaRegUser className="me-1" style={{fontSize: "16px"}}/> My account
                                  </Dropdown.Item>

                                  <Dropdown.Item
                                    onClick={() => {
                                      if (!isLoggingOut) {
                                        logout();
                                      }
                                    }}
                                    disabled={isLoggingOut}
                                    className="d-flex align-items-center text-danger px-0 py-1"
                                    style={{
                                      fontSize: "16px",
                                      opacity: isLoggingOut ? 0.6 : 1,
                                      cursor: isLoggingOut ? "not-allowed" : "pointer",
                                    }}
                                  >
                                    <FaSignOutAlt className="me-1" style={{fontSize: "16px"}}/> {isLoggingOut ? "Signing Out..." : "Sign Out"}
                                  </Dropdown.Item>

                                  {/* {loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT && (
                                    <>
                                      <Dropdown.Divider />
                                      <div className="small text-muted">
                                        <div
                                          style={{ position: "relative", display: "inline-block" }}
                                          onMouseEnter={() => setShowQueueTooltip(true)}
                                          onMouseLeave={() => setShowQueueTooltip(false)}
                                        >
                                          <div
                                            className="text-primary"
                                            style={{
                                              cursor: agentGroups.length > 0 ? "pointer" : "default",
                                              fontSize: "0.85rem",
                                              fontWeight: 600,
                                              display: "inline-flex",
                                              alignItems: "center",
                                              gap: "6px"
                                            }}
                                          >
                                            <span style={{ color: "#4c4a4aff" }}>
                                              Assigned Queue:
                                            </span>
                                            <span
                                            >
                                              View ({agentGroups?.length})
                                            </span>
                                          </div>

                                          {showQueueTooltip && agentGroups.length > 0 && (
                                            <div
                                              style={{
                                                position: "absolute",
                                                top: "120%",
                                                right: 0,
                                                backgroundColor: "#fff",
                                                borderRadius: "8px",
                                                boxShadow: "0 16px 32px rgba(0,0,0,0.18)",
                                                padding: "12px",
                                                minWidth: "410px",
                                                zIndex: 9999,
                                                border: "1px solid rgba(0,0,0,0.07)",
                                              }}
                                              onMouseEnter={() => setShowQueueTooltip(true)}
                                              onMouseLeave={() => setShowQueueTooltip(false)}
                                            >
                                          
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "space-between",
                                                  marginBottom: 6,
                                                  borderBottom: "1px solid rgba(0,0,0,0.08)",
                                                  paddingBottom: 4,
                                                }}
                                              >
                                                <div style={{ fontSize: "0.8rem", fontWeight: 600 }}>
                                                  Assigned Groups
                                                </div>

                                                {agentGroups.length > pageSize && (
                                                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        setQueuePage((p) => Math.max(0, p - 1));
                                                      }}
                                                      disabled={!hasPrev}
                                                      style={{ border: "none", background: "transparent" }}
                                                    >
                                                      <FaChevronLeft />
                                                    </button>
                                                    <span style={{ fontSize: "0.75rem" }}>
                                                      {queuePage + 1}/{totalPages}
                                                    </span>
                                                    <button
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        setQueuePage((p) => Math.min(totalPages - 1, p + 1));
                                                      }}
                                                      disabled={!hasNext}
                                                      style={{ border: "none", background: "transparent" }}
                                                    >
                                                      <FaChevronRight />
                                                    </button>
                                                  </div>
                                                )}
                                              </div>

                                              {paginatedGroups.map((grp, idx) => (
                                                <div key={idx} style={{ padding: "6px 0" }}>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: "12px",
                                                      flexWrap: "wrap",
                                                    }}
                                                  >
                                                    <div style={{ fontWeight: 600 }}>
                                                      {grp.group_name}
                                                    </div>

                                                    <div style={{ fontSize: "0.75rem", color: "#555" }}>
                                                      {grp.schedule?.start_time} - {grp.schedule?.end_time}
                                                    </div>
                                                  </div>

                                                  <div style={{ fontSize: "0.72rem", color: "#777" }}>
                                                    {grp.schedule?.week_days?.join(", ")}
                                                  </div>
                                                </div>

                                              ))}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  )} */}
                                </Dropdown.Menu>

                            </Dropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </Fragment>

        <Modal
          show={showLogoutModal}
          onHide={() => setShowLogoutModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Logout Confirmation</Modal.Title>
          </Modal.Header>

        <Modal.Body>
          You are currently logged in on your mobile device.

          <br />
          <br />

          Would you like to:
        </Modal.Body>

        <Modal.Footer>

          <Button
            variant="secondary"
            onClick={() => {
                setShowLogoutModal(false);
                logout(true);
            }}
          >
            Logout from Dashboard Only
          </Button>

          <Button
            variant="danger"
            onClick={() => {
                setShowLogoutModal(false);
                logout(false);
            }}
          >
            Logout from Dashboard and Mobile
          </Button>

        </Modal.Footer>
      </Modal>

          <div style={{display: "none" }}>
          <button className="disconnect2"></button>
          <button className="keypadConnect2"></button>
          </div>
                {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps}/> */}

                  </>
              )
          })

export default Header
  
